export default "__VITE_ASSET__42de478d__"